import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

const resetDialog = () => ({
    open:   null,
    draft:  {}
});

class DialogStore extends ReduceStore {

    getOpenDialog() {
        return this.getState().open;
    }

    getDraft() {
        return this.getState().draft;
    }

    getValue(key, defaultValue) {
        const draft = this.getState().draft;
        if (draft[key] !== undefined) {
            return draft[key];
        } else if (defaultValue !== undefined) {
            return defaultValue;
        } else {
            return undefined;
        }
    }
    
    getInitialState() {
        return resetDialog();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.DIALOG_OPEN:
                return update(this.getState(), {
                    open:   { $set: action.payload.dialog },
                    draft:  { $set: action.payload.draft || {} }
                });

            case ActionTypes.DIALOG_DRAFT_SET:
                return update(this.getState(), {
                    draft: { $set: action.payload.draft || {}}
                });

            case ActionTypes.DIALOG_DRAFT_UPDATE:
                return update(this.getState(), {
                    draft: {
                        [action.payload.field]: { $set: action.payload.value }
                    }
                });

            case ActionTypes.DIALOG_DRAFT_BULK_UPDATE:
                let updates = {};
                for (let field in action.payload.updates) {
                    if (action.payload.updates.hasOwnProperty(field)) {
                        if (action.payload.updates[field] !== undefined) {
                            updates[field] = { $set: action.payload.updates[field] };
                        }
                    }
                }
                return update(this.getState(), { draft: updates });

            case ActionTypes.DIALOG_CLOSE:
                return resetDialog();

            default:
                return state;
        }
    }
}

export default new DialogStore(CentricDispatcher);
